import { render } from "./WallpaperListProp.vue?vue&type=template&id=5b0313e5"
import script from "./WallpaperListProp.vue?vue&type=script&lang=js"
export * from "./WallpaperListProp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__